"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnqurieCallToActionType = void 0;
var EnqurieCallToActionType;
(function (EnqurieCallToActionType) {
    EnqurieCallToActionType[EnqurieCallToActionType["Website"] = 1] = "Website";
    EnqurieCallToActionType[EnqurieCallToActionType["Email"] = 2] = "Email";
    EnqurieCallToActionType[EnqurieCallToActionType["Phone"] = 3] = "Phone";
    EnqurieCallToActionType[EnqurieCallToActionType["WhatsApp"] = 4] = "WhatsApp";
    EnqurieCallToActionType[EnqurieCallToActionType["WeChat"] = 5] = "WeChat";
    EnqurieCallToActionType[EnqurieCallToActionType["Titan"] = 6] = "Titan";
})(EnqurieCallToActionType = exports.EnqurieCallToActionType || (exports.EnqurieCallToActionType = {}));
